import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Organization, SessionTimeout } from 'src/app/services/organization.model';
import { OrganizationService } from '../organization.service';
import { UserService } from 'src/app/services/user.service';

interface PrimaryContact {
  userName: string;
  emailAddress: string;
  password: string;
}
interface OrganizationResponse {
  status: boolean;
  id: number;
  message?: string; // Use optional chaining if `message` may not always be present
}

@Component({
    selector: 'app-create-organization-dialog',
    templateUrl: './create-organization-dialog.component.html',
    styleUrls: ['./create-organization-dialog.component.css'],
    standalone: false
})
export class CreateOrganizationDialogComponent implements OnInit {

  public organizationdata: Organization;
  public sessionTimeout:   SessionTimeout;
  ;
  public primaryContact: PrimaryContact;
  dialogTitle: string;
  isEdit: boolean;
  errorMessage: string | null = null; // Holds the error message
  statusOptions = [
    { value: 1, label: 'Active' },
    { value: 0, label: 'In-Active' },
    { value: 2, label: 'Trial' }
  ];

 userTypes = [
  { id: 1, label: 'Super Admin', timeout: 60 },  // Or skip this one in logic
  { id: 2, label: 'Admin', timeout: 60 },
  { id: 3, label: 'Analyst', timeout: 30 },
  { id: 4, label: 'Operator', timeout: 15 }
];


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private organizationService: OrganizationService,
    private userService: UserService,
    private dialogRef: MatDialogRef<CreateOrganizationDialogComponent>
  ) {
    this.dialogTitle = data.title || 'Create Organization';

    // Initialize organization data
    // Initialize organization data with default status as "Active"
    this.organizationdata = { 
      ...new Organization(), 
      status: 1, // Default status to "Active"
      ...data.organization // Merge incoming organization data if present
    };
    this.isEdit = !!this.organizationdata.id; // Determine edit mode based on `id`
    // Initialize primary contact
  /*  this.primaryContact = {
      userName: '',
      emailAddress: '',
      password: '',
      ...data.primaryContact // If primary contact is passed, merge it
    };*/
  }

  ngOnInit(): void {}

  async onSave(): Promise<void> {
    console.log('Saving organization:', this.organizationdata);

    // Check if this is an edit mode
    const isEditMode = !!this.organizationdata.id;

    if (isEditMode) {
      await this.updateOrganization();
    } else {
      await this.createOrganization();
    }
  }
  private async createOrganization(): Promise<void> {
    const orgExistFlag = await this.organizationService.checkOrganizationExists(
      this.organizationdata.organizationName,
      0
    );
  
    if (!orgExistFlag?.status) {
      this.errorMessage = 'Organization name already taken. Please use a different name.';
      return;
    }
  
    const organizationResponse = await this.organizationService.createOrganization(this.organizationdata);
  
    if (!organizationResponse || !organizationResponse.status) {
      console.error('Organization creation failed:', organizationResponse?.message || 'Unknown error');
      this.dialogRef.close({
        status: false,
        message: organizationResponse?.message || 'Organization creation failed.',
      });
      return;
    }
  
    // Insert session timeouts for roles that have timeout values
    const insertPromises: Promise<any>[] = [];
  
    this.userTypes.forEach(userType => {
      if (userType.timeout !== undefined && userType.timeout !== null) {
        const sessionTimeout = {
          organizationId: organizationResponse.id,
          roleId: userType.id,
          timeout: userType.timeout,
          status: true
        };
  
        insertPromises.push(
          this.organizationService.insertOrganizationSessionTimeout(sessionTimeout)
        );
      }
    });
  
    try {
      await Promise.all(insertPromises);
      console.log('Session timeout entries inserted successfully.');
    } catch (error) {
      console.error('Error inserting session timeouts:', error);
      // Optionally handle or log error
    }
  
    // Close dialog with success
    this.dialogRef.close({
      status: true,
      message: 'Organization created successfully with session timeouts',
      data: organizationResponse,
    });
  }
  
  /*private async createOrganization(): Promise<void> {
    const orgExistFlag = await this.organizationService.checkOrganizationExists(
      this.organizationdata.organizationName,
      0
    );
   // console.log("orgExistFlag", orgExistFlag);
    
    // Check if user exists
   // const userExistFlag = await this.userService.checkUserNameExists(this.primaryContact.userName);
  //  console.log("userExistFlag", userExistFlag);
    
    // Determine error messages based on the response
   // if (!orgExistFlag?.status && !userExistFlag?.status) {
      //if (!orgExistFlag?.status) {
      // Both are false
     // this.errorMessage = 'Organization name are already taken. Please use different values.';
     // return; // Stop further execution
    //}
    
    if (!orgExistFlag?.status) {
      // Organization name is false
      this.errorMessage = 'Organization name already taken. Please use a different name.';
      return; // Stop further execution
    }
    
    //if (!userExistFlag?.status) {
      // Username is false
    //  this.errorMessage = 'Primary contact User ID already taken. Please use a different User ID.';
     // return; // Stop further execution
    //}
    
    // If both are true, proceed with the rest of the code
    if (orgExistFlag.status ) {
      // Your rest of the code here
   //   console.log('Both organization and user are valid. Proceeding with creation...');
    
      // Step 1: Create the primary contact (user)
     // const userResponse = await this.createPrimaryContact();
    
     // if (!userResponse || !userResponse.id) {
        // Check if the error indicates the contact already exists
     //   if (userResponse?.message?.includes('already taken')) {
      //    this.errorMessage = 'Primary contact already taken. Please use a different User ID.';
    //    } else {
       //   this.errorMessage = userResponse?.message || 'Primary contact creation failed.';
      //  }
      //  return; // Stop further execution if primary contact creation fails
    //  }
    
     // console.log('Primary contact created successfully:', userResponse);
    
      // Step 2: Create the organization
    //  this.organizationdata.primaryContact = this.primaryContact.userName; // Assign the user's ID as the primary contact
      const organizationResponse = await this.organizationService.createOrganization(this.organizationdata);
    
      if (!organizationResponse || !organizationResponse.status) {
        console.error('Organization creation failed:', organizationResponse?.message || 'Unknown error');
        this.dialogRef.close({
          status: false,
          message: organizationResponse?.message || 'Organization creation failed.',
        });
        return; // Exit function if organization creation fails
      }
    
      //console.log('Organization created successfully:', organizationResponse);
    //
      // Step 3: Assign the organization to the user
    //  const userOrgData = {
     //   userId: userResponse.id,
    //    organizationId: organizationResponse.id,
   //   };
    
   //   const organizationAssignResponse = await this.userService.assignOrganization(userOrgData).toPromise();
    
     // if (!organizationAssignResponse || !organizationAssignResponse.status) {
      //  console.error('Organization assignment failed:', organizationAssignResponse?.message || 'Unknown error');
      //  this.dialogRef.close({
      //    status: false,
     //     message: organizationAssignResponse?.message || 'Organization assignment failed.',
     //   });
    //    return; // Exit function if organization assignment fails
   //   }
    
    //  console.log('AssignOrganization created successfully:', organizationAssignResponse);
    
      // Close dialog with success status
      this.dialogRef.close({
        status: true,
        message: 'Organization created successfully',
        data: organizationResponse,
      });


    }
    
  }*/
  

  private async updateOrganization(): Promise<void> {
    try {
      // Update the organization
      const response = await this.organizationService.updateOrganization(this.organizationdata);
      console.log('Organization updated successfully:', response);

      // Optionally, update the primary contact
     // if (this.primaryContact.userName || this.primaryContact.emailAddress || this.primaryContact.password) {
     //   await this.updatePrimaryContact();
     // }

      this.dialogRef.close({
        status: true,
        message: 'Organization updated successfully',
        data: response
      });
    } catch (error) {
      console.error('Error updating organization:', error);
      this.dialogRef.close({
        status: false,
        message: error.message || 'An error occurred while updating the organization.'
      });
    }
  }

 /* private async createPrimaryContact(): Promise<any> {
    const userData = {
      userName: this.primaryContact.userName,
      emailAddress: this.primaryContact.emailAddress,
      password: this.primaryContact.password,
      userType: 2, // Define the type of user
      firstName: 'Admin',
      lastName: this.organizationdata.organizationName,
      //organizationId:orgId,
      status:1
    };

    return this.userService.createUser(userData); // Call the user service to create a user
  }*/

  private async updatePrimaryContact(): Promise<void> {
    const userData = {
      userName: this.primaryContact.userName,
      emailAddress: this.primaryContact.emailAddress,
      password: this.primaryContact.password
    };

    await this.userService.updateUser(userData); // Call the user service to update the user
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
